export default __webpack_public_path__ + "static/media/back10.f471b939.png";